/**
 * Deze klasse reageert op de properties curr_fase en curr_page, op basis van "kind" wordt via de factory
 * de juiste pagina getoond. Binnen App worden curr_fase en curr_page aangepast, dit script hoeft alleen nog te weten
 * wel/niet ingelogd ivm tonen logout en logboek (vanaf curr_fase > 0)
 *
 *
 * @history
 * 14 juni 2023
 * het uitvoeren van een ronde is een wat complexer geheel, hiervoor is voorlopig 1 aparte container die alle 6 stappen doorloopt. In het cms is er wel per stap een pagina (mbv programmers_field) zodat er per stap teksten ingevoerd kunnen worden.
 * de container "round" regelt dit allemaal.
 *
 * 20 juli 2022
 * Start implementatie
 *
 */
import React from 'react';
import {Page} from "../pages/Page";
import {PagePlaceholder} from "../pages/PagePlaceholder";
import {PageNavBar} from "../helpers/PageNavBar";
import {LoginPage} from "../pages/LoginPage";
//import {GroupBuilder} from "../pages/GroupBuilder";
import {RoundManager} from "../round/RoundManager";
import {SessionSelection} from "../helpers/SessionSelection";

const page_kinds = {
    page: Page,
    login: LoginPage,
   // groupbuilder: GroupBuilder,
   // grouplogviewer:GroupBuilder,
    placeholder: PagePlaceholder,
    round: RoundManager,
    session_selection:SessionSelection
};

function PageFactory(props) {
    let SpecificPage;
    if (page_kinds.hasOwnProperty(props.kind)) {
        SpecificPage = page_kinds[props.kind];
    } else {
        SpecificPage = page_kinds.placeholder;
    }

    if (props.kind == "groupbuilder" )
    {
        props.show_log = false;
    }

    if (props.kind == "grouplogviewer" )
    {
        props.show_log = true;
    }

    if (props.kind == "round")
    {
        props.mode = props.page.programmers_field;
    }

    return <SpecificPage {...props}  />;
}

export class ContentWrapper extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <div className={"tool__content__wrapper"}>

                    <PageFactory
                        curr_fase={this.props.curr_fase}
                        curr_page={this.props.curr_page}
                        session_active={this.props.session_active}

                        page={window.app.pageHandler.getPageContent(this.props.curr_fase, this.props.curr_page)}
                        kind={window.app.pageHandler.getPageKind(this.props.curr_fase, this.props.curr_page)}
                        key={"page_" + window.app.pageHandler.getPageID(this.props.curr_fase, this.props.curr_page)}

                        sessions={this.props.sessions}


                    />

                </div>
                { window.app.pageHandler.getPageKind(this.props.curr_fase, this.props.curr_page)  != "round" && (
                        <PageNavBar curr_fase={this.props.curr_fase}
                                    hide_prev ={window.app.pageHandler.getPageKind(this.props.curr_fase, this.props.curr_page) == "session_selection"}
                                    tot_pages={window.app.pageHandler.getTotPages(this.props.curr_fase)}
                                    curr_page={this.props.curr_page}
                                    hide_next={window.app.pageHandler.getPageKind(this.props.curr_fase, this.props.curr_page) == "login" || window.app.pageHandler.getPageKind(this.props.curr_fase, this.props.curr_page) == "session_selection"}/>
                )}
            </>
        );
    }

}
